import { FormProvider } from 'react-hook-form'
import { Spinner } from '../../../components/ui/spinner'
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from '../../../components/ui/tabs'
import { TeamsMembersPage } from '../TeamsMembersPage'
import { TeamsTransactionPage } from '../TeamsTransactionsPage'
import { TeamCardDetails } from './components/TeamCardDetails'
import { useTeamsDetailsPageController } from './useTeamsDetailsPageController'
import { SellersProvider } from '../../../../app/contexts/SellerContex'
import { TablesCard } from './components/TablesCard'

export const TeamsDetailsPage = () => {
  const { data, isFetching, isLoading, methods } =
    useTeamsDetailsPageController()

  return (
    <SellersProvider>
      <div className="flex flex-col items-start">
        <Tabs defaultValue="transactions" className="w-full">
          <TabsList className="mb-10 flex justify-start gap-2 bg-transparent xs:mb-4 xs:gap-6">
            <TabsTrigger
              className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
              value="transactions"
            >
              Transações
            </TabsTrigger>
            <TabsTrigger
              className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
              value="members"
            >
              Membros
            </TabsTrigger>
          </TabsList>
          {(isFetching || isLoading) && (
            <div className="flex h-screen w-full items-center justify-center">
              <Spinner />
            </div>
          )}

          <div className="flex w-full flex-col items-start gap-6 md:flex-row lg:gap-12">
            <div className="flex w-full max-w-[450px] flex-col gap-6">
              <FormProvider {...methods}>
                {data && <TeamCardDetails {...data} />}
              </FormProvider>
              <FormProvider {...methods}>
                {data && <TablesCard {...data} />}
              </FormProvider>
              {/* <FormProvider {...methods}>
                {data && <GoalsCard {...data} />}
              </FormProvider> */}
            </div>

            <div className="w-full">
              <TabsContent value="transactions" className="w-full">
                <TeamsTransactionPage />
              </TabsContent>
              <TabsContent value="members" className="w-full">
                <TeamsMembersPage />
              </TabsContent>
            </div>
          </div>
        </Tabs>
      </div>
    </SellersProvider>
  )
}
